var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserBottomNav = function SvgUserBottomNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#user-bottom-nav_svg__a)",
    fillRule: "evenodd",
    d: "M6.75 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M10 1.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5M17.75 18v-5.75H2.25V18h1.5v-4.25h12.5V18z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "user-bottom-nav_svg__a",
    x1: 15.564,
    x2: -1.147,
    y1: 1.52,
    y2: 13.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgUserBottomNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02Ljc1IDZDNi43NSA0LjIwNTA3IDguMjA1MDcgMi43NSAxMCAyLjc1QzExLjc5NDkgMi43NSAxMy4yNSA0LjIwNTA3IDEzLjI1IDZDMTMuMjUgNy43OTQ5MyAxMS43OTQ5IDkuMjUgMTAgOS4yNUM4LjIwNTA3IDkuMjUgNi43NSA3Ljc5NDkzIDYuNzUgNlpNMTAgMS4yNUM3LjM3NjY1IDEuMjUgNS4yNSAzLjM3NjY1IDUuMjUgNkM1LjI1IDguNjIzMzUgNy4zNzY2NSAxMC43NSAxMCAxMC43NUMxMi42MjM0IDEwLjc1IDE0Ljc1IDguNjIzMzUgMTQuNzUgNkMxNC43NSAzLjM3NjY1IDEyLjYyMzQgMS4yNSAxMCAxLjI1Wk0xNy43NSAxOFYxMi4yNUgyLjI1VjE4SDMuNzVWMTMuNzVIMTYuMjVWMThIMTcuNzVaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMzQ1OF8xMjMpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMzQ1OF8xMjMiIHgxPSIxNS41NjQxIiB5MT0iMS41MjAxNiIgeDI9Ii0xLjE0NjY0IiB5Mj0iMTMuMDY2OCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuMTI2MzAyIiBzdG9wLWNvbG9yPSIjRkY3ODgwIi8+CjxzdG9wIG9mZnNldD0iMC4zNzQ0IiBzdG9wLWNvbG9yPSIjMTVDRkU0Ii8+CjxzdG9wIG9mZnNldD0iMC42MjUxNTQiIHN0b3AtY29sb3I9IiMzQkYyQTUiLz4KPHN0b3Agb2Zmc2V0PSIwLjg3NjM0OCIgc3RvcC1jb2xvcj0iIzY2NzVGRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";